import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-storage.js";
import { getAuth, signInAnonymously, onAuthStateChanged } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js";
import { initializeAppCheck, ReCaptchaV3Provider } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app-check.js";

// Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyChmQt2UuguUQFo6hSLU_KBczgV6vpVHlo",
    authDomain: "photopri-uploads.firebaseapp.com",
    projectId: "photopri-uploads",
    storageBucket: "photopri-uploads.firebasestorage.app",
    messagingSenderId: "697919935874",
    appId: "1:697919935874:web:a910d4f3afd7124eac6b9b"
};

const app = initializeApp(firebaseConfig);

// [2026-06-23 Phase1] App Check (reCAPTCHA v3) — bot/直叩きを弾く防御層。site key が実値のときだけ
// 初期化(プレースホルダのままだと init 失敗でアップロードがブロックされ得るため、未設定時はスキップ
// して従来挙動を温存)。実値設定 + Firebase Console 登録 + Storage Enforce は 2.8.01 公開時に有効化。
// 本番では self.FIREBASE_APPCHECK_DEBUG_TOKEN を絶対に設定しない。
const RF_APPCHECK_SITE_KEY = "6LfujUwtAAAAAKLnekUNal5OgrOpWHBCo7Ceh-BS";
if (RF_APPCHECK_SITE_KEY && RF_APPCHECK_SITE_KEY.indexOf("__") === -1) {
    try {
        initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(RF_APPCHECK_SITE_KEY),
            isTokenAutoRefreshEnabled: true
        });
    } catch (e) {
        console.warn("RF: App Check init skipped", e);
    }
}

// [2026-07-10] reCAPTCHA バッジ非表示(Google規約準拠の文言はフォーム下に表示)。
(function () {
    try {
        var s = document.createElement('style');
        s.textContent = '.grecaptcha-badge{visibility:hidden !important;}';
        (document.head || document.documentElement).appendChild(s);
    } catch (e) { /* noop */ }
})();

const storage = getStorage(app);
const auth = getAuth(app);

// [2026-06-23 Phase1] 匿名認証。uid 配下パス + ルール限定の前提。authReady(Promise<uid>) を公開し、
// await はアップロード直前(rf-base-form.js handleFiles)で行う。init 段で await しない(module 評価/フォーム生成を遮らない)。
window.RF_FIREBASE = {
    storage, ref, uploadBytesResumable, getDownloadURL,
    auth,
    uid: null,
    authReady: null
};
window.RF_FIREBASE.authReady = new Promise((resolve, reject) => {
    onAuthStateChanged(auth, (user) => {
        if (user) {
            window.RF_FIREBASE.uid = user.uid;
            resolve(user.uid);
        }
    });
    signInAnonymously(auth).catch((err) => {
        console.error("RF: anonymous sign-in failed", err);
        reject(err);
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const formType = window.rfConfig?.formType;
    console.log("RF: Booting with Form Type:", formType);

    const CUSTOM_TYPES = ['aluminum_overmat', 'print_only', 'aluminum_unified', 'wood_unified', 'wood_panel', 'styrene_panel', 'canvas_panel', 'book_matte'];

    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
        // Prevent double initialization
        if (form.dataset.rfInitialized) return;

        // [ST-31] 同一商品ページに /cart/add フォームが複数あるケース(例: Shop Pay 分割払いの
        // <payment-terms> フォーム、sticky-bar 等)では、補助フォームにも CustomOrderForm を
        // 生成すると this.container が共通の商品セクションに解決され、サイズ切替スイッチャー等の
        // 共有 UI にリスナーが二重バインドされる。結果、定形/定形外トグルが1クリックで2回発火し
        // 元に戻る(＝定形外が選べない)。入稿 UI を持たない補助フォームは初期化対象から除外する。
        // [2026-07-17] form.id は使えない: フォーム内の <input name="id">(Shopify の variant id)が
        // HTMLFormElement の名前付きゲッターで `id` プロパティを上書きする(DOM clobbering)ため、
        // form.id は文字列でなく input 要素を返す。結果 /payment-installment/.test(form.id) は
        // "[object HTMLInputElement]" を検査することになり永久に false だった(このガードの半分が死んでいた)。
        // 属性を直接読めば clobbering の影響を受けない。
        if (form.closest('payment-terms') || /payment-installment/.test(form.getAttribute('id') || '')) return;

        form.dataset.rfInitialized = 'true';

        if (formType && CUSTOM_TYPES.includes(formType)) {
            new window.CustomOrderForm(form);
        } else if (formType) {
            new window.CustomOrderForm(form);
        } else {
            new window.RationalFuturismForm(form);
        }
    });

    // [2026-07-11] reCAPTCHA 規約表記(バッジ非表示のため Google 規約で必須)。
    // reCAPTCHA(App Check)はファイルアップロード(Firebase Storage)を保護する層なので、
    // アップロードエリア(#rf-dropzone)が存在するフォームにのみ表示する。
    // [2026-07-15 修正] アップロード不要のフォーム(全用紙サンプル等)にも forms[0] フォールバックで
    // 表示されていた不具合を解消。dropzone が無い場合は挿入しない。
    // [2026-07-16 締め] frame_only(額装のみ)は dropzone が DOM に残るが親セクションが
    // display:none。offsetParent === null は祖先に display:none がある(=アップロード非提供)
    // ことを意味するので、可視な dropzone のときだけ挿入し「隠れた通知DOM」も作らない。
    const dz = document.querySelector('#rf-dropzone');
    if (dz && dz.offsetParent !== null && !document.querySelector('.rf-recaptcha-notice')) {
        const n = document.createElement('div');
        n.className = 'rf-recaptcha-notice';
        n.style.cssText = 'font-size:11px;line-height:1.6;color:#9aa0a6;margin-top:12px;text-align:center;';
        n.innerHTML = 'このサイトは reCAPTCHA によって保護されており、Google の '
            + '<a href="https://policies.google.com/privacy" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">プライバシーポリシー</a> と '
            + '<a href="https://policies.google.com/terms" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">利用規約</a> が適用されます。';
        dz.insertAdjacentElement('afterend', n);
    }

    // [2026-06 価格表ディープリンク復元] 商品ページに ?variant=ID で来た場合、
    // 該当バリアントのサイズを入稿フォームの「納品サイズ」に初期選択する。
    // 旧テーマの標準バリアントピッカーが ?variant= で行っていた自動選択を、
    // カスタム入稿フォーム上で再現する。手動選択と同一の change を発火するため
    // 価格・用紙フィルタ・レイアウト制限も既存ロジックで再計算される。
    try {
        const variantId = new URLSearchParams(window.location.search).get('variant');
        if (variantId) {
            const variants = (window.rfConfig && window.rfConfig.mainVariants) || [];
            const matched = variants.find(v => String(v.id) === String(variantId));
            const targetSize = matched && (matched.option1 || (matched.options && matched.options[0]));
            if (targetSize) {
                let applied = false;
                forms.forEach(form => {
                    const sizeSelect = form.querySelector('#rf-size-select')
                        || form.querySelector('select[name^="properties[\u30b5\u30a4\u30ba"]');
                    if (!sizeSelect) return;
                    const hit = Array.from(sizeSelect.options).some(o => o.value === targetSize);
                    if (hit && sizeSelect.value !== targetSize) {
                        sizeSelect.value = targetSize;
                        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                        applied = true;
                    }
                });
                console.log('RF: size pre-select from ?variant=', variantId, '->', targetSize, '| applied:', applied);
            }
        }
    } catch (err) {
        console.warn('RF: size pre-select skipped', err);
    }
});
